import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { URL } from '../../../environments/environment';

import { empresaRouteAnimations } from './empresa-route.animations';

@Component({
  selector: 'app-empresa-shell',
  templateUrl: './empresa-shell.component.html',
  styleUrls: ['./empresa-shell.component.scss'],
  animations: [empresaRouteAnimations]
})
export class EmpresaShellComponent {
  readonly navItems: ReadonlyArray<{
    label: string;
    desc: string;
    route?: string;
    href?: string;
  }> = [
    { label: 'Nosotros', desc: 'Conócenos', route: 'nosotros' },
    { label: 'Nuestro Data Center', desc: 'Infraestructura', route: 'data-center' },
    { label: 'Formas de Pago', desc: 'Fácil y rápido', route: 'formas-pago' },
    { label: 'Términos y Condiciones', desc: 'Adecuado uso', href: URL.HAULMER_LEGAL_WEB_HOSTING },
    { label: 'Reclamos', desc: 'Tú eres importante', href: URL.SUPPORT_SUGGESTIONS }
  ];

  prepareRoute(outlet: RouterOutlet): string | undefined {
    return outlet?.isActivated ? outlet.activatedRouteData?.['animation'] : undefined;
  }
}
